// extracted by mini-css-extract-plugin
module.exports = {"link":"PopularPostsList_link__LRrCN"};